module.exports = __webpack_public_path__ + "static/media/w3w.61922f3d.svg";